import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AuthService } from './services/auth.service';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { AngularPlugin } from '@microsoft/applicationinsights-angularplugin-js';
import { ErrorHandlerService } from './services/error-handler.service';
import { Subscription, timer } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterModule]
})
export class AppComponent implements OnInit {
  title = 'Monitor2';
  private dailyReloadSubscription: Subscription;
  private routerEventsSubscription: Subscription;
  private authUserSubscription: Subscription;

  /**
     * Action : constructor()
     *
     * @private object __authService
     * 
     * @return void
     *-----------------------------------------------------------------------*/
  constructor(
    private __authService:AuthService, 
    private titleService: Title, 
    private translateService: TranslateService,
    private router: Router
  ) {
    //   var angularPlugin = new AngularPlugin();
    //   const appInsights = new ApplicationInsights({ config: {
    //   connectionString:environment.appInsights.connectionString,
    //   extensions: [angularPlugin],
    //   extensionConfig: {
    //       [angularPlugin.identifier]: {
    //         router: this.router,
    //         errorServices: [new ErrorHandlerService()]
    //       }
    //     }
    //   } 
    // });
    // appInsights.loadAppInsights();
  }

   /**
    * Action : ngOnInit()
    *
    * This function use for load component ts file
    *
    * @return void
    *-----------------------------------------------------------------------*/
  ngOnInit(): void {
    this.__authService.__autoLoginUser();  

    this.authUserSubscription = this.__authService.__loggedInUserData.subscribe((res: any) => {
        let isLoggedIn = !!res;
        let mou = res?.mou;
        let mat = res?.mat;            

        // If the current route is an autologin route, do not perform any redirects 
        // to avoid interfering with the autologin process
        if(this.isAutoLoginRoute(window.location.pathname)) {
          return;
        }

        if (isLoggedIn) {
            const selectedLang = localStorage.getItem('selectedLanguage');
            if(selectedLang) {
              this.translateService.use(selectedLang);
            }else{
              const defaultLang = res.lang || 'de';
              this.translateService.use(defaultLang);
              localStorage.setItem('selectedLanguage', defaultLang);
            }

            if (mat == true) {
                // alarm tablet user
                this.router.navigate(['monitor/alarmtablet']);
            } else if(mou == true){
                //if monitor overview user
                this.router.navigate(['monitor/overview']);
            }else{
                // default monitor dashboard user
                this.router.navigate(['monitor/dashboard']);
            }
        } else {
          this.translateService.use('de');
        }
    });
    
    // Subscribe to translation change event and update the title when the language changes
    this.translateService.onLangChange.subscribe(() => {
      this.updateTitle();
    });

    // Reload monitors daily
    this.startDailyReload();
  }

  private isAutoLoginRoute(path: string): boolean {
    const sanitizedPath = (path || '').split('?')[0];
    return /^\/autologin\/.+/.test(sanitizedPath);
  }

  startDailyReload() {
    // Calculate time until next 1 AM
    const now = new Date();
    const next1AM = new Date();
    next1AM.setHours(1, 0, 0, 0);

    // If 1 AM has already passed today, schedule for tomorrow at one
    if (next1AM.getTime() <= now.getTime()) {
      next1AM.setDate(next1AM.getDate() + 1);
    }

    const delayUntil1AM = next1AM.getTime() - now.getTime();
    const dailyIntervalMs = 1000 * 60 * 60 * 24; // 24 hours

    // Use timer to emit at next one o'clock, then every 24 hours
    // Add random delay (0-15 min) before reload to distribute load across monitors
    this.dailyReloadSubscription = timer(delayUntil1AM, dailyIntervalMs)
      .subscribe(() => {
        const randomDelayMs = Math.random() * 15 * 60 * 1000; // Random 0-15 minutes
        setTimeout(() => {
          window.location.reload();
        }, randomDelayMs);
      });
  }

  private updateTitle() {
    const translatedTitle = this.translateService.instant('Retter Alarm : Monitor Panel');
    this.titleService.setTitle(translatedTitle);
  }

  ngOnDestroy() {
    if (this.dailyReloadSubscription) {
      this.dailyReloadSubscription.unsubscribe();
    }

    if (this.routerEventsSubscription) {
      this.routerEventsSubscription.unsubscribe();
    }

    if (this.authUserSubscription) {
      this.authUserSubscription.unsubscribe();
    }
  }

}
